import type { CockpitTarget } from "@kundeninfo/api-client";
import { filterAusSegment, RECHNUNGS_FILTER } from "../../bereichsfilter.js";
import type { Route } from "../../router.js";
import { AKTEN_TABS } from "../KundenAkte.js";

/** Rechnungen: Das Segment gilt nur aus Kennungen der Tabelle; „alle“ ist wie im Router die eine Adresse ohne Filter. */
function invoiceRoute(segment: string | undefined): Route {
  const filter = filterAusSegment(segment ?? "", RECHNUNGS_FILTER);
  return filter === null || filter.length === 0 || filter.length === RECHNUNGS_FILTER.length
    ? { name: "rechnungen" } : { name: "rechnungen", filter };
}

/**
 * Das Sprungziel einer Kachel oder Zeile als Route, an dieser einen Stelle. Das Board ist die Tickets-Route ohne Ansicht. `filter`
 * gilt bei Tickets nicht: Den Listenfilter „Fälligkeitsfenster“ gibt es noch nicht, die Zeile springt in die Zeitachse (K28). Ein
 * unbekannter Reiter öffnet die Übersicht der Akte, die Quelle reist mit (K27). Ein Ticket ist kein Ort, sondern ein Objekt: Es
 * öffnet als Objektpanel, sonst springt es über `sprungZiel` (Öffnen statt Springen A8, F10) — hier gibt es dafür keine Route.
 */
export function routeOfTarget(t: Exclude<CockpitTarget, { kind: "TICKET" }>): Route {
  if (t.kind === "CUSTOMER") {
    return { name: "kunde", id: t.customerId, tab: AKTEN_TABS.find((a) => a.id === t.tab)?.id ?? "uebersicht",
      ...(t.objectId === undefined ? {} : { vorgangId: t.objectId }),
      ...(t.folderId === undefined ? {} : { folderId: t.folderId }), source: "cockpit", herkunft: "cockpit" };
  }
  if (t.area === "rechnungen") return invoiceRoute(t.filter);
  if (t.area === "angebote") return { name: "angebote" };
  return t.view === undefined || t.view === "board" ? { name: "tickets" } : { name: "tickets", ansicht: t.view };
}
